import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Bubble from '@/Components/Bubble/Bubble';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { c } from 'ttag';
const SearchBubbles = ({ searchOptions }) => {
    const { includeProtectedContents, includeArchived, includeTrashed } = searchOptions;
    const toggleIncludeProtectedContents = useCallback(async () => {
        await searchOptions.toggleIncludeProtectedContents();
    }, [searchOptions]);
    return (_jsxs(_Fragment, { children: [_jsx(Bubble, { label: c('B3.Notes.NoteList.Label').t `Protected Contents`, selected: includeProtectedContents, onSelect: toggleIncludeProtectedContents }), _jsx(Bubble, { label: c('B3.Notes.NoteList.Action').t `Archived`, selected: includeArchived, onSelect: searchOptions.toggleIncludeArchived }), _jsx(Bubble, { label: c('B3.Notes.NoteList.Action').t `Trashed`, selected: includeTrashed, onSelect: searchOptions.toggleIncludeTrashed })] }));
};
export default observer(SearchBubbles);
